
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Clock, ChevronRight } from 'lucide-react';

// Mock data - in a real app, this would come from API calls
const mockRelatedArticles = [
  {
    id: 2, 
    title: "Understanding the Global Chip Shortage",
    excerpt: "The semiconductor industry faces unprecedented challenges as demand soars...",
    author: {
      name: "Michael Chen",
      avatar: "/placeholder.svg"
    },
    publishedAt: "2023-05-10T14:30:00Z",
    readTime: 12
  },
  {
    id: 3, 
    title: "New Research on Mental Health Benefits of Meditation",
    excerpt: "A groundbreaking study reveals significant improvements in cognitive function...",
    author: {
      name: "Sophia Lee",
      avatar: "/placeholder.svg"
    },
    publishedAt: "2023-05-08T09:15:00Z",
    readTime: 6
  },
  {
    id: 4, 
    title: "The Evolution of Remote Work Culture",
    excerpt: "How companies are redefining collaboration and productivity in the digital age...",
    author: {
      name: "David Wong",
      avatar: "/placeholder.svg"
    },
    publishedAt: "2023-05-05T11:45:00Z",
    readTime: 10
  }
];

interface ArticleRelatedProps {
  currentArticleId: string;
}

const ArticleRelated: React.FC<ArticleRelatedProps> = ({ currentArticleId }) => {
  // Format date to be more readable
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) {
      return "Today";
    } else if (diffDays === 1) {
      return "Yesterday";
    } else if (diffDays < 7) {
      return `${diffDays} days ago`;
    } else {
      return date.toLocaleDateString(undefined, { 
        month: 'short', 
        day: 'numeric' 
      });
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {mockRelatedArticles.map(article => (
        <Card key={article.id} className="overflow-hidden hover:shadow-md transition-shadow">
          <Link to={`/article/${article.id}`} className="block">
            <div className="aspect-video bg-muted relative">
              <img 
                src="/placeholder.svg" 
                alt={article.title} 
                className="w-full h-full object-cover"
              />
            </div>
            <CardContent className="p-4">
              <h3 className="font-bold mb-2 line-clamp-2 hover:text-primary transition-colors">
                {article.title}
              </h3>
              <p className="text-sm text-muted-foreground line-clamp-2 mb-4">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <Avatar className="h-6 w-6 mr-2">
                    <AvatarImage src={article.author.avatar} alt={article.author.name} />
                    <AvatarFallback>{article.author.name.substring(0, 2)}</AvatarFallback>
                  </Avatar>
                  <span className="text-xs">{article.author.name}</span>
                </div>
                <div className="flex items-center text-xs text-muted-foreground">
                  <Clock className="h-3 w-3 mr-1" />
                  <span>{article.readTime} min</span>
                </div>
              </div>
            </CardContent>
          </Link>
        </Card>
      ))}
    </div>
  );
};

export default ArticleRelated;
